import { useQuery } from '@tanstack/react-query';
import type { EDITABLE_EMAIL_KINDS } from '@servwell/shared';
import { useTRPC } from '../../lib/trpc';
import { StatusBadge } from '../ui/Badge';
import { EditWordingButton } from './EmailWordingSheet';

/**
 * "Edit wording" for one kind of email (MAP 249 tickets 05 + 07): Settings → Email draws one on
 * every row of "Automatic emails" (all seven editable kinds, spec §6 ruling D). It is ticket 05's
 * opener (`EditWordingButton`: the button, and the sheet it opens for `kind`), with "Your wording"
 * beside it once the server has said the shop saved its own (`emailWording.list`, one read for
 * all seven rows). The owner edits (`org:manage`); the office sees the wording ("See wording").
 */
export function EditWordingSlot({
  kind,
}: {
  kind: (typeof EDITABLE_EMAIL_KINDS)[number];
}) {
  const trpc = useTRPC();
  const list = useQuery(trpc.emailWording.list.queryOptions());
  // Only once the server has answered: before that, "ours" would be a claim nobody checked.
  const edited = list.data?.some((w) => w.kind === kind && w.edited) ?? false;
  return (
    <>
      {edited ? <StatusBadge tone="brand">Your wording</StatusBadge> : null}
      <EditWordingButton kind={kind} />
    </>
  );
}
